import styled, { css } from 'styled-components';
import { SPACING_32 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { RADIUS_0, RADIUS_2 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';
import { DEEP_BORDER_BOX } from 'common';

const getBorderStyle = ({
  disabled, inputFocused, error, readOnly, hasOutline, $theme
}) => {
  let borderStyle;
  if (!disabled) {
    if (readOnly) {
      borderStyle = ' solid transparent';
    } else if (error) {
      borderStyle = ` solid ${$theme.error.border}`;
    } else if (inputFocused) {
      borderStyle = ` solid ${$theme.focused.border}`;
    } else {
      borderStyle = ` solid ${$theme.border}`;
    }
  } else {
    borderStyle = hasOutline ? ` solid ${$theme.disabled.border} ` : ` dotted ${$theme.disabled.border} `;
  }
  return borderStyle;
};

const setStyleByType = ({
  hasOutline, disabled, inputFocused, error, readOnly, $theme
}) => {
  const borderStyle = getBorderStyle({
    disabled,
    error,
    inputFocused,
    hasOutline,
    readOnly,
    $theme
  });
  const borderWidth = error || inputFocused ? '0.125rem' : '0.0625rem';
  let style = '';
  if (hasOutline) {
    style = css`
      border-radius: ${RADIUS_2};
      border: ${borderWidth} ${borderStyle};
      background-color: ${!disabled ? $theme.background : `${$theme.disabled.background}`};
    `;
  } else if (!hasOutline) {
    style = css`
      border-radius: ${RADIUS_0};
      border-bottom: ${borderWidth} ${borderStyle};
      border-top: 0.0625rem solid transparent;
      border-right: none;
      border-left: none;
      background-color: transparent;
    `;
  }
  return style;
};

export default {
  ErrorMessage: styled.div`
    width: 7.5rem;
    margin-top: 0.125rem;
    font-family: 'NokiaPureRegular';
    font-size: 0.6875rem;
    ${({ $theme, $rtl }) => `
    color: ${$theme.color};
    direction: ${$rtl ? 'rtl' : 'ltr'}
    `}
  `,
  Spinner: styled.div`
    ${DEEP_BORDER_BOX}
    width: 7.5rem;
    height: 2rem;
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${props => setStyleByType(props)};
  `,
  // width and height is little less. So outer container Spinner will have room for border changes without effect content.
  SpinnerContainer: styled.div`
    height: ${SPACING_32};
    outline: none;
    display: flex;
    justify-content: space-between;
    ${props =>
    !props.$rtl
      ? css`
            flex-direction: row;
          `
      : css`
            flex-direction: row-reverse;
          `}
  `
};
